import React, { useEffect, useRef, useState } from "react";
import NIALeftPanel from "./simulatorLeftPanel";
import { Radio, RadioGroup } from "rsuite";
import Slider from "../../components/common/Slider/Slider";
import RebateTrend from "./rebateTrend";
import SpendShift from "./spendShift";
import {
	getAllNIASimulator,
	getNIASimulatorData,
	updateNIASimulatorData,
} from "../../queries/apiQueries";
import "./niaSimulator.scss";
import { appInsights } from "../router";
import { SpendFlag } from "../constants";
import { useSelector } from "react-redux";
import ToggleSwitch from "../../components/common/ToggleSwitch";
import MainHeader from "../../components/Layouts/MainHeader";
import MainContent from "../../components/Layouts/MainContent";
import { Segmented } from "antd";
import { Loader } from "../../components/common/Loader";
import ArrowDropDownCircleOutlinedIcon from '@mui/icons-material/ArrowDropDownCircleOutlined';

const NIASimulator = (props: any) => {
	const approachSelected = useSelector(
		(state: any) => state.CommonReducer.approach
	);
	const [isRightVisible, setIsRightVisible] = useState(false);
	const [value, setValue] = useState<any>("1");
	const [loading, setLoading] = useState(false);
	const [isCalculated, setIsCalculated] = useState(false);
	const [spendText, setSpendText] = useState("Sales");
	const [isVisible, setIsVisible] = useState(false);
	const [selectedFilter, setSelectedFilter] = useState<any>({
		vendor_name: [],
		rebateCategory: ["Overall"],
	});
	const [filterData, setFilterData] = useState({
		vendors: [],
		rebateCategories: [],
	});
	const [moreDetails, setMoreDetails] = useState(false);

	const didMount = useRef(false);
	const sliderChange = useRef(false);
	const [niaSimulatorData, setNiaSimulatorData] = useState<any>({
		spendBreakdownByCategories: {},
		kpi: {},
		rebateData: {},
		oppEq: {},
		extraElementsForCalc: {},
		step1: [],
	});

	const [sliderData, setSliderData] = useState<any>({
		rebateData: {},
		extraElementsForCalc: {},
	});

	const [updatedStep1, setUpdatedStep1] = useState([]);
	const [updatedStep2, setUpdatedStep2] = useState([]);
	const [greenPivotValue, setGreenPivotValue] = useState({
		greenPivot: "",
		greenPivotValue: 0,
	});

	const [niaSimulatorChangingData, setNiaSimulatorChangingData] = useState({
		nextTierSpend: 0,
		lastYearSpend: 0,
		foreCastedSpend: 0,
		spendMovement: 0,
		additionalPurchases: 0,
		isZeroPurchase: false,
	});
	const [kpiChnagingData, setKpiChangingData] = useState({
		targetEffectiveRebate: 0,
	});

	console.log(niaSimulatorChangingData,'niaSimulatorChangingData')

	const preparePayload = (calculate: boolean = false) => {
		let payload: any = {
			vendor_name: selectedFilter?.vendor_name,
		};

		if (calculate) {
			if (updatedStep2?.length !== 0) {
				updatedStep2?.forEach((value: any) => {
					value.adjDistricProportionBasedOnCompletedQtySpend =
						value.adjDistricProportionBasedOnCompletedQtySpend /
						100;
				});
			}
			payload = {
				vendor_name: selectedFilter?.vendor_name,
				step1:
					updatedStep1?.length !== 0
						? updatedStep1
						: niaSimulatorData?.step1,
				step2:
					updatedStep2?.length !== 0
						? updatedStep2
						: niaSimulatorData?.step2,
				extraElementsForCalc: {
					greenPivot: greenPivotValue?.greenPivot,
					greenPivotValue: greenPivotValue?.greenPivotValue,
					lastYearSpend:
						niaSimulatorData?.extraElementsForCalc?.lastYearSpend,
					yellowPivot:
						niaSimulatorData?.extraElementsForCalc?.yellowPivot,
				},
				oppEq: {
					spendRequiredForNextTier:
						niaSimulatorChangingData?.nextTierSpend,
					forecastedSpendBasedOnYTDGrowth:
						niaSimulatorChangingData?.foreCastedSpend,
					spendMovementFromPeers:
						niaSimulatorChangingData?.spendMovement,
					additionalPurchasesRequired:
						niaSimulatorChangingData?.additionalPurchases,
				},
				kpi: {
					currenEffectiveRebate:
						niaSimulatorData?.kpi?.currenEffectiveRebate,
					targetEffectiveRebate:
						kpiChnagingData?.targetEffectiveRebate,
					totalBenefit: niaSimulatorData?.kpi?.totalBenefit,
				},
				benifitEq: {
					addtionalInventoryCarryingCost:
						niaSimulatorData?.benifitEq
							?.addtionalInventoryCarryingCost,
					addtionalInventoryCarryingCostProportion:
						niaSimulatorData?.benifitEq
							?.addtionalInventoryCarryingCostProportion,
					decreaseNiaReabteForPeers:
						niaSimulatorData?.benifitEq?.decreaseNiaReabteForPeers,
					increaseNiaRebate:
						niaSimulatorData?.benifitEq?.increaseNiaRebate,
				},
			};
		}
		setIsCalculated(calculate);
		payload.approach = approachSelected ? approachSelected : "approach1";
		return payload;
	};

	const [chartData, setChartData] = useState(null);

	const getNIASimulatorDataHandler = (calculate: boolean = false) => {
		console.log(calculate, "cal");
		getNIASimulatorData(preparePayload(calculate))
			.then((response) => {
				if (response?.status === 200) {
					setNiaSimulatorData(response?.data);
					prepareDataForNia(response?.data);
					if (
						response?.data?.kpi?.eligibilityCriteria == "Purchases"
					) {
						setSpendText(SpendFlag.Purchases);
					} else if (
						response?.data?.kpi?.eligibilityCriteria == "Sales"
					) {
						setSpendText(SpendFlag.Sales);
					}
				}
				setLoading(false);
				if (!calculate) {
					setUpdatedStep2([]);
					setUpdatedStep1([]);
				}
			})
			.catch((err) => {
				setLoading(false);
				console.log(err);
			});
	};

	const getAllNIASimulatorData = (loadType: number = 1) => {
		setLoading(true);
		getAllNIASimulator({
			vendor_name: selectedFilter?.vendor_name,
			approach: approachSelected ? approachSelected : "approach1",
		})
			.then((response) => {
				if (response?.status === 200) {
					if (loadType === 0) {
						setSelectedFilter({
							...selectedFilter,
							vendor_name: [
								response?.data?.vendors[0]?.vendor_name,
							],
						});
						setFilterData({
							vendors: response?.data?.vendors,
							rebateCategories: response?.data?.rebateCategories,
						});
					} else {
						setFilterData({
							...filterData,
							rebateCategories: response?.data?.rebateCategories,
						});
					}
					// if (response?.data?.vendors[0]?.EligibilityCriteria == 'Purchases'){
					//   setSpendText(SpendFlag.Purchases);
					// } else if(response?.data?.vendors[0]?.EligibilityCriteria == 'Sales'){
					//   setSpendText(SpendFlag.Sales);
					// }
					sliderChange.current = false;
				}
			})
			.catch((err) => {
				setLoading(false);
				console.log(err);
			});
	};

	const prepareDataForNia = (data: any) => {
		let pivotValue =
			parseFloat(
				data?.extraElementsForCalc?.greenPivot?.replace("%", "")
			) / 100;
		let lastYearSpend = data?.extraElementsForCalc?.lastYearSpend;
		let oppEq = data?.oppEq;
		setNiaSimulatorChangingData({
			...niaSimulatorChangingData,
			nextTierSpend:
				data?.oppEq?.additionalPurchasesRequired != 0
					? lastYearSpend * pivotValue
					: oppEq?.spendRequiredForNextTier,
			lastYearSpend: lastYearSpend,
			foreCastedSpend: oppEq?.forecastedSpendBasedOnYTDGrowth,
			spendMovement: oppEq?.spendMovementFromPeers,
			additionalPurchases: oppEq?.additionalPurchasesRequired,
			isZeroPurchase:
				data?.oppEq?.additionalPurchasesRequired !== 0 ? false : true,
		});
		setGreenPivotValue({
			greenPivotValue: data?.extraElementsForCalc?.greenPivotValue,
			greenPivot: data?.extraElementsForCalc?.greenPivot,
		});
		setKpiChangingData({
			...kpiChnagingData,
			targetEffectiveRebate: data?.kpi?.targetEffectiveRebate,
		});
	};

	const calculateSpendShiftHandler = () => {
		let additionalPurchases =
			niaSimulatorChangingData?.nextTierSpend -
			niaSimulatorChangingData?.foreCastedSpend -
			niaSimulatorChangingData?.spendMovement;
		setNiaSimulatorChangingData({
			...niaSimulatorChangingData,
			additionalPurchases: additionalPurchases,
		});
	};


	useEffect(() => {
		appInsights.trackPageView({
			name: `Navigate to NIA Simulator by ${localStorage.getItem(
				"name"
			)}`,
		});
		if (didMount?.current && sliderChange.current) {
			calculateSpendShiftHandler();
		} else {
			didMount.current = true;
		}
	}, [
		niaSimulatorChangingData?.nextTierSpend,
		niaSimulatorChangingData?.spendMovement,
	]);

	useEffect(() => {
		getAllNIASimulatorData(0);
	}, []);

	useEffect(() => {
		if (selectedFilter?.vendor_name?.length !== 0) {
			getNIASimulatorDataHandler();
			getAllNIASimulatorData(1);
		}
	}, [selectedFilter]);

	const getRebateValue = (data: any) => {
		setIsCalculated(false);
		console.log(sliderChange.current,'sliderChange.current')
		let greenPivot: any = Number(data)?.toFixed(2);
		let newRebate = niaSimulatorData?.rebateData[greenPivot + "%"];
		setGreenPivotValue({
			greenPivot: greenPivot + "%",
			greenPivotValue: newRebate,
		});
		if (newRebate >= 0) {
			setKpiChangingData({
				...kpiChnagingData,
				targetEffectiveRebate:
					niaSimulatorData?.rebateData?.rebate_base + newRebate,
			});
		}
		if (sliderChange.current) {
			if (
				(niaSimulatorChangingData?.lastYearSpend * greenPivot) / 100 >
				niaSimulatorChangingData?.foreCastedSpend
			) {
				setNiaSimulatorChangingData({
					...niaSimulatorChangingData,
					nextTierSpend:
						(niaSimulatorChangingData?.lastYearSpend * greenPivot) /
						100,
				});
			} else {
				setNiaSimulatorChangingData({
					...niaSimulatorChangingData,
					nextTierSpend: niaSimulatorChangingData?.foreCastedSpend,
				});
			}
		}
	};

	const spendMovementSumHandler = (data: any) => {
		setIsCalculated(false);
		var result = data.reduce(function (acc: number, obj: any) {
			return acc + obj?.adjSpendToBemoved;
		}, 0);
		setNiaSimulatorChangingData({
			...niaSimulatorChangingData,
			spendMovement: result,
		});
	};

	const onFilterSelect = (data: any, key: number) => {
		if (key === 1) {
			setSelectedFilter({
				...selectedFilter,
				vendor_name: data ? [data] : [],
			});
		} else {
			setSelectedFilter({
				...selectedFilter,
				rebateCategory: data ? [data] : [],
			});
		}
	};

	const updateNIASimulatorDataHandler = () => {
		let payload = {
			vendor_name: selectedFilter?.vendor_name,
			approach: approachSelected ? approachSelected : "approach1",
			step1: niaSimulatorData?.step1,
			step2: niaSimulatorData?.step2,
			extraElementsForCalc: niaSimulatorData?.extraElementsForCalc,
			kpi: niaSimulatorData?.kpi,
			benifitEq: niaSimulatorData?.benifitEq,
		};
		updateNIASimulatorData(payload)
			.then((response) => {
				if (response?.status === 200) {
					getNIASimulatorDataHandler();
					setValue("2");
				}
				setIsCalculated(false);
			})
			.catch((err) => {
				console.log(err);
			});
	};
	const handleToggleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setValue(event?.target?.checked ? "2" : "1");
	};

	return (
		<div>
			{loading && <Loader />}

			{!loading && (
				<div className="opportunities-dashboard-container w-full ">
					<MainHeader
						onVisibilityChange={setIsVisible}
						isRightVisible={isRightVisible}
						setIsRightVisible={setIsRightVisible}
						topContent={
							<>
								<div className="flex justify-between items-center w-full">
									<div className="text-left pageline">
										<span className="pagelinestart">
											NIA
										</span>{" "}
										<span className="pagelineslash">/</span>{" "}
										<span className="pagelinesub">
											Forward Buy Recommendation
										</span>
									</div>
								</div>
								<div className="execution-level-wrapper">
									<div className="execution-level-title">
										View By
									</div>
									<Segmented
										options={[
											{
												label: `${spendText} Shift/Increase Inputs`,
												value: "1",
											},
											{
												label: `${spendText} & Rebate Trend View`,
												value: "2",
											},
										]}
										value={value}
										onChange={setValue}
									/>
								</div>
							</>
						}
					></MainHeader>
					<MainContent isVisible={isVisible} fullHeight={true}>
						<div className="grid grid-cols-4 gap-6 h-[100%]">
							<div className="h-[100%] w-full  ">
								<NIALeftPanel
									onFilterSelect={onFilterSelect}
									filterData={filterData}
									selectedFilter={selectedFilter}
									data={niaSimulatorData}
									kpiChnagingData={kpiChnagingData}
									value={value}
									spendText={spendText}
								/>
							</div>
							<div className=" col-span-3 h-[100%] w-full contentBox overflow-y-hidden">
								<div className="common-table-header-row !mb-1">
									<div className="common-table-header flex-nowrap">
										Selected Approach:{" "}
										{approachSelected
											? approachSelected == "approach1"
												? "Approach 1"
												: approachSelected ==
												  "approach2"
												? "Approach 2"
												: "Approach 3"
											: "Approach 1"}
									</div>
									{/* {value === "1" && niaSimulatorData && (
										<div>
											<span className="segtitle">
												Scroll To:
											</span>
											<Segmented
												options={[
													{
														label: "Implementation",
														value: "step1",
													},
													{
														label: "Execution",
														value: "step2",
													},
												]}
												value={selectedSection}
												onChange={setSelectedSection}
											/>
										</div>
									)} */}
								</div>
								<div className="simulator-slider-header flex justify-between items-center">
									<p className="text-black font-weight-700 font-bold text-fs16"></p>
									<div className="flex gap-x-[2.5vh]">
										<div className="flex gap-x-[.8vh] not-italic text-[1.5vh] pr-[1vh]">
											<div className="triangle"></div>
											<span className="text-black textSmall">
												{" "}
												Growth % based on YTD{" "}
												{spendText}{" "}
											</span>
										</div>
										<div className="flex gap-x-[.8vh] not-italic text-[1.5vh] pr-[1vh]">
											<div className="triangle greenColor"></div>
											<span className="text-black textSmall">
												{" "}
												Growth required for next tier{" "}
											</span>
										</div>
									</div>
								</div>

								<Slider
									leftPivot={
										// value === "2"?
										//   (
										//   sliderData?.extraElementsForCalc?.yellowPivot * 100
										// ).toFixed(2)
										// :
										(
											niaSimulatorData
												?.extraElementsForCalc
												?.yellowPivot * 100
										).toFixed(2)
									}
									rightPivot={parseFloat(
										niaSimulatorData?.extraElementsForCalc?.greenPivot?.replace(
											"%",
											""
										)
									)}
									handleSliderChange={(value: any) => {
										getRebateValue(value);
									}}
									view={
										value === "2"
											? "trendView"
											: "spendshift"
									}
									rebate={niaSimulatorData?.rebateData}
									sliderChange={sliderChange}
								/>

								{value === "2" && niaSimulatorData && (
									<RebateTrend
										data={niaSimulatorData}
										spendText={spendText}
									/>
								)}
								{value === "1" && niaSimulatorData && (
									<SpendShift
										moreDetails={moreDetails}
										spendMovementSumHandler={
											spendMovementSumHandler
										}
										niaSimulatorChangingData={
											niaSimulatorChangingData
										}
										data={niaSimulatorData}
										updateStep1={setUpdatedStep1}
										updateStep2={setUpdatedStep2}
										onCalculateNIA={() =>
											getNIASimulatorDataHandler(true)
										}
										onSave={updateNIASimulatorDataHandler}
										isCalculated={isCalculated}
										updateIsCalculated={(i: any) => {
											setIsCalculated(i);
										}}
										niaSimulatorData={
											niaSimulatorData?.spendBreakdownByCategories
										}
										spendText={spendText}
									/>
								)}
								<div className="w-full flex flex-col justify-center items-center">
									{ !moreDetails &&
									<>
										<p className="textMedium italic text-black mt-[-1vh] pb-[1vh]">
											Please click on expand icon for more details
										</p>
										<ArrowDropDownCircleOutlinedIcon
											color="action"
											onClick={()=>setMoreDetails(true)}
										/>
									</>
									}
									{ moreDetails &&
										<ArrowDropDownCircleOutlinedIcon
											color="action"
											className="rotate-180 mt-[3vh]"
											onClick={()=>setMoreDetails(false)}
										/>
									}
								</div>
							</div>
						</div>
					</MainContent>
				</div>
			)}
		</div>
	);
};

export default NIASimulator;
